import React from "react";
import { Box, Typography, Button, Grid } from "@mui/material";

const TaskCalendar = ({ currentDate, selectedDates, handlePrevMonth, handleNextMonth, handleSelectedDatesUpdate }) => {
  const daysOfWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const generateCalendar = () => {
    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    const startDay = startOfMonth.getDay();
    const totalDays = endOfMonth.getDate();

    const days = [];
    for (let i = 0; i < startDay; i++) days.push(null);
    for (let i = 1; i <= totalDays; i++) days.push(i);
    return days;
  };

  const handleDateClick = (day) => {
    if (!day) return; // Ignore if day is null or undefined

    // Create a date for the clicked day in the local time zone (without any shift)
    const selectedFullDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

    // Update the selected dates array
    const updatedDates = selectedDates?.includes(selectedFullDate)
      ? selectedDates?.filter((date) => date !== selectedFullDate)
      : [...selectedDates, selectedFullDate];

    // Notify the parent to update the state
    handleSelectedDatesUpdate(updatedDates);
  };

  const days = generateCalendar();

  return (
    <Box>
      <Box display='flex' justifyContent='space-between' alignItems='center' mb={2}>
        <Button onClick={handlePrevMonth}>&lt;</Button>
        <Typography variant='h6'>
          {currentDate.toLocaleString("default", { month: "long" })} {currentDate.getFullYear()}
        </Typography>
        <Button onClick={handleNextMonth}>&gt;</Button>
      </Box>

      <Grid container spacing={1}>
        {daysOfWeek.map((day, index) => (
          <Grid item xs={1.7} key={index}>
            <Typography variant='body2' fontWeight='bold'>
              {day}
            </Typography>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={1}>
        {days.map((day, index) => (
          <Grid item xs={1.7} key={index}>
            {day ? (
              <Box
                onClick={() => handleDateClick(day)}
                sx={{
                  width: "35px",
                  height: "35px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  borderRadius: "50%",
                  bgcolor: selectedDates?.includes(
                    `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, "0")}-${day
                      .toString()
                      .padStart(2, "0")}`
                  )
                    ? "#1976d2"
                    : "transparent",
                  color: selectedDates?.includes(
                    `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, "0")}-${day
                      .toString()
                      .padStart(2, "0")}`
                  )
                    ? "white"
                    : "black",
                  "&:hover": { bgcolor: "#eeeeee" },
                }}
              >
                {day}
              </Box>
            ) : (
              <Box sx={{ width: "35px", height: "35px" }}></Box>
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TaskCalendar;
